import { formatRoleLabel } from '../platform/roleLabels';
import { displayUserName } from './userDisplay';

export function normalizeUserSearchValue(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function buildUserSearchHaystack(user, units = []) {
  const unitName = units.find((unit) => unit.id === user.unit)?.unitName || '';
  return normalizeUserSearchValue([
    displayUserName(user),
    user.displayName,
    user.email,
    user.firstName,
    user.lastName,
    user.phone,
    user.jobPosition,
    user.workArea,
    unitName,
    formatRoleLabel(user.role),
    user.role,
  ].filter(Boolean).join(' '));
}

export function matchesUserSearch(user, units, query) {
  const normalizedQuery = normalizeUserSearchValue(query.trim());
  if (!normalizedQuery) {
    return true;
  }

  const haystack = user.searchHaystack || buildUserSearchHaystack(user, units);
  return haystack.includes(normalizedQuery);
}
